import _ from 'lodash'

import { NotificationService } from '@/services/retailer/NotificationService'

export const namespaced = true

export const state = {
  notifications: [],
  meta: {},
  total_unread: 0
}

export const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = state.notifications.concat(notifications.data)
    state.meta = notifications.meta
    state.total_unread = notifications.total_unread
  },
  DELETE_NOTIFICATION(state, id) {
    state.notifications = _.filter(state.notifications, function (notification) {
      return notification.id !== id
    })
  },
  SET_NOTIFICATION(state, notification) {
    let index = _.findIndex(state.notifications, item => item.id === notification.id)
    if (index === -1) {
      return
    }
    state.notifications.splice(index, 1, notification)
  }
}

export const actions = {
  getNotifications({ commit, state }, from) {
    return new Promise(resolve => {
      from = from || 1
      NotificationService.getNotifications(from).then(response => {
        commit('SET_NOTIFICATIONS', response)
        resolve(response.data)
      })
    })
  },
  markAsRead({ commit, state }, id) {
    return new Promise(resolve => {
      NotificationService.markAsRead(id).then(response => {
        commit('SET_NOTIFICATION', response)
        resolve(response)
      })
    })
  },
  deleteNotification({ commit, state }, id) {
    return new Promise(resolve => {
      NotificationService.delete(id).then(response => {
        commit('DELETE_NOTIFICATION', id)
        resolve(response)
      })
    })
  }
}
